export const NewPermPlacementDetailsGetters = {
  PermPlacement: 'NewPermPlacementDetailsGetters.PermPlacement'
};

export const NewPermPlacementDetailsActions = {
  RetrievePermPlacement: 'NewPermPlacementDetailsActions.RetrievePermPlacement',
  RetrievePermPlacementAttachments:
    'NewPermPlacementDetailsActions.RetrievePermPlacementAttachments',
  DoPermPlacementAction: 'NewPermPlacementDetailsActions.DoPermPlacementAction',
  ResetPermPlacementState: 'NewPermPlacementDetailsActions.ResetPermPlacementState'
};

export const NewPermPlacementDetailsMutations = {
  RetrievePermPlacementSuccess: 'NewPermPlacementDetailsMutations.RetrievePermPlacementSuccess',
  RetrievePermPlacementAttachmentsSuccess:
    'NewPermPlacementDetailsMutations.RetrievePermPlacementAttachmentsSuccess',
  SetLoading: 'NewPermPlacementDetailsMutations.SetLoading',
  ResetPermPlacementState: 'NewPermPlacementDetailsMutations.ResetPermPlacementState'
};
